import _ from 'lodash';
import React from 'react';
import { StatusDetails, StatusItemsDetails } from '../../status';
import { IStatusDetailProps } from './status-detail.types';
import * as S from '../claim-timeline.styles';
import { TextRow, AmountRow } from '../timeline-row-components';

export const StatusItemsDetail: React.FunctionComponent<IStatusDetailProps> = (
    props: IStatusDetailProps
): React.ReactElement | null => {
    const { status } = props;
    if (!status) {
        return null;
    }

    const hasDetails = !!status.details?.length;
    const hasItems = !!status.items?.length;
    const lastDetail = hasDetails
        ? _.chain(status.details).sortBy('adjudicationFinalizedDate').last().value()
        : undefined;
    const chargeAmount = lastDetail?.totalChargeAmount;
    const paidAmount = lastDetail?.totalPaidAmount;

    const hasSummaryTable =
        status.id != null ||
        status.claimControlNumber != null ||
        status.patientControlNumber != null ||
        status.externalId != null ||
        status.statusType != null ||
        chargeAmount != null ||
        paidAmount != null;

    if (!hasSummaryTable && !hasDetails && !hasItems) {
        return null;
    }

    return (
        <S.ExpandCol>
            {hasSummaryTable && (
                <S.ExpandTable>
                    <S.ExpandTBody>
                        <TextRow label="ID" value={status.id} />
                        <TextRow label="Claim #" value={status.claimControlNumber} />
                        <TextRow label="Patient Account #" value={status.patientControlNumber} />
                        <TextRow label="External ID" value={status.externalId} />
                        <TextRow label="Status" value={status.statusType} />
                        <AmountRow label="Billed" value={chargeAmount} />
                        <AmountRow label="Paid" value={paidAmount} />
                    </S.ExpandTBody>
                </S.ExpandTable>
            )}
            {hasDetails && <StatusDetails details={status.details!} />}
            {hasItems && <StatusItemsDetails items={status.items!} />}
        </S.ExpandCol>
    );
};
